import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { ClientBackgroundColorChange as BackgroundColorChange } from "~/components/bloks/CollectionPageBlok/ClientBackgroundColorChange";
import type { CollectionPageStoryblok } from "~/generated/sb/blok-types";
import styles from "./CollectionPageBlok.module.css";

export const CollectionPageBlok = ({ blok, preview }: BlokProps<CollectionPageStoryblok>) => {
	const Title = () =>
		!blok?.Title ? null : (
			<h1 className={clsx(styles.hero__heading, "blok-big-title")}>{blok.Title}</h1>
		);
	const Subtitle = () =>
		!blok?.shortDescription ? null : (
			<h2 className={clsx("blok-subtitle", styles.hero__subtitle)}>{blok.shortDescription}</h2>
		);

	return (
		<BlokWrap as="main" editable={blok} className="collection-page">
			<BackgroundColorChange
				color={
					typeof blok.backgroundColor === "number"
						? `#${blok.backgroundColor}`
						: (blok.backgroundColor ?? "var(--color-background)")
				}
			/>
			<div data-layout="blok" className={styles.hero}>
				<Title />
				<Subtitle />
			</div>

			{blok.content?.map((currentBlok) => (
				<StoryblokComponent
					preview={preview}
					blok={currentBlok}
					key={`current-blok--${currentBlok._uid}`}
				/>
			))}
		</BlokWrap>
	);
};
